import { useIsFeatureVisible } from '../hooks/useIsFeatureVisible';
import { VisibilityConfig } from '../types';
import { FeatureFormField } from './FeatureForm';
import { Field } from './FeatureForm/types';

type FieldsProps = {
  fields?: Field[];
  visibilityConfig?: VisibilityConfig;
};

export const Fields = ({ fields, visibilityConfig }: FieldsProps) => {
  const isFieldsVisible = useIsFeatureVisible(visibilityConfig);

  if (!isFieldsVisible) {
    return null;
  }

  return (
    <div className="grid grid-cols-4 gap-4">
      {fields?.map((field) => <FeatureFormField key={field.name} {...field} />)}
    </div>
  );
};
